import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Canonical host hop: if the site is browsed on an alias of the backend domain
// (e.g. apex jayatk.com while the build points at www.jayatk.com), reload once on
// the canonical origin — cross-origin edge redirects strip the Authorization
// header from POSTs, which breaks authenticated admin actions.
if (typeof window !== "undefined" && BACKEND_URL) {
  try {
    const baked = new URL(BACKEND_URL);
    const root = (h) => h.split(".").slice(-2).join(".");
    if (root(baked.hostname) === root(window.location.hostname) && window.location.origin !== baked.origin) {
      window.location.replace(baked.origin + window.location.pathname + window.location.search + window.location.hash);
    }
  } catch { /* non-URL config — ignore */ }
}

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jayatk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
